import { Component, effect, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TooltipsService } from "@kno2/common/services";
import { APP_TOAST_KEY } from "@kno2/common/services/notifications";
import { Toast } from "primeng/toast";
import { StartupService } from "./startup.service";

@Component({
    imports: [RouterOutlet, Toast],
    selector: "app-root",
    templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit {
    protected readonly toastKey = APP_TOAST_KEY;
    private readonly tooltipsService = inject(TooltipsService);
    private readonly startupService = inject(StartupService);

    public constructor() {
        effect(() => this.startupService.isReady() && this.startupService.start());
    }

    public ngOnInit(): void {
        try {
            this.tooltipsService.init();
        } catch (err) {
            console.error(err);
        }
    }
}
